var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-tabs',{attrs:{"tab-refs":_vm.tabRefs},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('rkm-tab',{attrs:{"active":"","title":"Pendentes"}},[_c('Pendente',{ref:"Pendente"})],1),_c('rkm-tab',{attrs:{"title":"Permissões"}},[_c('Permissao',{ref:"Permissao"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }